import DataTable from '../DataTable';
import { useDataTableHandle } from '../DataTable';

const IpaffsModaltable = ({
  data = [],
  updateData = () => {},
  setPaginationLoaded = () => {},
  persist = '',
  setPersist = () => {},
  handleClose = () => {},
  children,
}) => {
  const dth = useDataTableHandle();
  return (
    <div className="px-3">
      <DataTable
        handle={dth}
        lazyLoading
        data={data}
        className="table-striped"
        onUpdate={updateData}
        onPaginationLoaded={() => {
          setPaginationLoaded(true);
        }}
        showLowerCaseHeaders={true}
        persistGetter={persist}
        persistSetter={setPersist}
        idKey="key"
        editable
      >
        <DataTable.Head></DataTable.Head>
        {children}
      </DataTable>
    </div>
  );
};

export default IpaffsModaltable;
